/**
 * Every feature flag consumers can ask about, independent of the source that
 * backs it. Consumers only import this enum; `FEATURE_FLAG_SOURCE_NAMES` is the
 * one place that knows each flag's name in CloudBees or Connect.
 */
export enum FeatureFlag {
  OtaFirmwareUpdate = 'OtaFirmwareUpdate',
  TasksNavLink = 'TasksNavLink',
  ShareProject = 'ShareProject',
  AddTA = 'AddTA',
  Nosyncack = 'Nosyncack',
  Enable3d = 'Enable3d',
  Devicelastsync = 'Devicelastsync',
  Designtimeprediction = 'Designtimeprediction',
  Infielddesignsw = 'Infielddesignsw',
  Sharedevices = 'Sharedevices',
  Calibrationshareddevices = 'Calibrationshareddevices',
  Deletepartners = 'Deletepartners',
  Globalsearch = 'Globalsearch',
  Designviewer = 'Designviewer',
  Dataprep = 'Dataprep',
  Uploadpreview = 'Uploadpreview',
  Designviewerbackground = 'Designviewerbackground',
  Designviewerlayermanager = 'Designviewerlayermanager',
  Designviewerpropertiespanel = 'Designviewerpropertiespanel',
  Backgroundimagesviewer = 'Backgroundimagesviewer',
  Earthworksoperator = 'Earthworksoperator',
  Geoimagesearthworks = 'Geoimagesearthworks',
  Machineplayback = 'Machineplayback',
  Machinediary = 'Machinediary',
  Groundworksdiary = 'Groundworksdiary',
  Machinediarydailyreport = 'Machinediarydailyreport',
  WorkOrderBulkActions = 'WorkOrderBulkActions',
  Siteworksscreenview = 'Siteworksscreenview',
  Workorders = 'Workorders',
  Landxmldirectpublish = 'Landxmldirectpublish',
  EulaModal = 'EulaModal',
  Nosyncstatusforsiteworks = 'Nosyncstatusforsiteworks',
  BulkLicenseStatus = 'BulkLicenseStatus',
  FileExplorerDelete = 'FileExplorerDelete',
  Iso = 'Iso',
  Photogrammetry = 'Photogrammetry',
  PhotogrammetryTrimbleAccessGcps = 'PhotogrammetryTrimbleAccessGcps',
  PhotogrammetryDeleteGcps = 'PhotogrammetryDeleteGcps',
  PhotogrammetryGcpUnits = 'PhotogrammetryGcpUnits',
  PhotogrammetrySurfaceOutput = 'PhotogrammetrySurfaceOutput',
  PhotogrammetryPpRtx = 'PhotogrammetryPpRtx',
  Civil3dViewer = 'Civil3dViewer',
  Civil3dViewerDesignPackageManager = 'Civil3dViewerDesignPackageManager',
  Civil3dViewerProjectDataPanel = 'Civil3dViewerProjectDataPanel',
  Civil3dViewerToolbar = 'Civil3dViewerToolbar',
  Civil3dNonVclEditing = 'Civil3dNonVclEditing',
  Civil3dMultiUserDataPrep = 'Civil3dMultiUserDataPrep',
  Civil3dSplitJoin = 'Civil3dSplitJoin',
  Civil3dEnableTranslationButtons = 'Civil3dEnableTranslationButtons',
  Raauthentication = 'Raauthentication',
  Radynamicscope = 'Radynamicscope',
  Civil3dViewerTerrainSurfaceTexturing = 'Civil3dViewerTerrainSurfaceTexturing',
  Civil3dViewerOrthoImagery = 'Civil3dViewerOrthoImagery',
  Civil3dViewerFieldDataImporter = 'Civil3dViewerFieldDataImporter',
  Civil3dViewerConnectDataImporter = 'Civil3dViewerConnectDataImporter',
  Civil3dViewer3dTerrain = 'Civil3dViewer3dTerrain',
  Civil3dViewerS2SVolumetricMeasurements = 'Civil3dViewerS2SVolumetricMeasurements',
  Revokeselfinvite = 'Revokeselfinvite',
  Wmchatassistant = 'Wmchatassistant',
  Wmchataguiv2 = 'Wmchataguiv2',
  Wmchatplatformagent = 'Wmchatplatformagent',
  Customisableunitsettings = 'Customisableunitsettings',
  Civil3dViewerDrillingAndPiling = 'Civil3dViewerDrillingAndPiling',
  FolderContentsDelete = 'FolderContentsDelete',
  OtaSupportForRW = 'OtaSupportForRW',
  Civil3dViewerVolumeMeasurementGraphics = 'Civil3dViewerVolumeMeasurementGraphics',
  ProjectMigrationManually = 'ProjectMigrationManually',
  Civil3dViewerVolumeHeatmapColorPalette = 'Civil3dViewerVolumeHeatmapColorPalette',
  Civil3dViewerTerrainTimeline = 'Civil3dViewerTerrainTimeline',
  Civil3dViewerTerrainTimelinePhase2 = 'Civil3dViewerTerrainTimelinePhase2',
  Civil3dViewerTerrainTimelinePhase3 = 'Civil3dViewerTerrainTimelinePhase3',
  Civil3dViewerModelSpaceEditing = 'Civil3dViewerModelSpaceEditing',
  Civil3dTextEditing = 'Civil3dTextEditing',
  Civil3dViewerAgent = 'Civil3dViewerAgent',
  Civil3dViewerSectionsGeneration = 'Civil3dViewerSectionsGeneration',
  AnalyticsDashboard = 'AnalyticsDashboard',
  DeletedItems = 'DeletedItems',
  Civil3dViewerIssueManagement = 'Civil3dViewerIssueManagement',
  Happycamper = 'Happycamper',
  Civil3dViewerDataDetailView = 'Civil3dViewerDataDetailView',
  DraftingToolsv2 = 'DraftingToolsv2',
  CrsProjectSettings = 'CrsProjectSettings',
  Civil3dViewerFeaturesServices = 'Civil3dViewerFeaturesServices',
  Civil3dViewerWireframe = 'Civil3dViewerWireframe',
  Civil3dViewerLayersPanel = 'Civil3dViewerLayersPanel',
  Civil3dViewerVolumeHeatmapPaletteBarStopEditing = 'Civil3dViewerVolumeHeatmapPaletteBarStopEditing',
  Civil3dViewerTerrainVolumetric = 'Civil3dViewerTerrainVolumetric',
  DeviceStatusMessage = 'DeviceStatusMessage',
  Civil3dViewerPhotogrammetryMissions = 'Civil3dViewerPhotogrammetryMissions',
  Civil3dViewerRemoteOverride = 'Civil3dViewerRemoteOverride',
  SiteVizPdfImport = 'SiteVizPdfImport',
  TestFeature001 = 'TestFeature001',
  FeatureExtraction = 'FeatureExtraction',
}

export type FeatureFlagSourceName = 'cloudbees' | 'connect' | 'config';

export type FeatureFlagSourceNames = Partial<
  Record<FeatureFlagSourceName, string>
>;

// Record over the enum so adding a flag without mapping it fails to compile.
const FEATURE_FLAG_SOURCE_NAMES: Record<FeatureFlag, FeatureFlagSourceNames> = {
  [FeatureFlag.OtaFirmwareUpdate]: { cloudbees: '4004 - OTA Firmware Update' },
  [FeatureFlag.TasksNavLink]: {
    cloudbees: '4520 - Create Task for Work Order',
  },
  [FeatureFlag.ShareProject]: { cloudbees: '3722 - Topcon - Share Project' },
  [FeatureFlag.AddTA]: { cloudbees: '8345 - Add Trimble Access' },
  [FeatureFlag.Nosyncack]: { cloudbees: '8309 - Nosync Acknowledgement' },
  [FeatureFlag.Enable3d]: { cloudbees: '9892 - 3D Enabled Checkbox' },
  [FeatureFlag.Devicelastsync]: {
    cloudbees: 'Enable Project Devices Last Sync',
  },
  [FeatureFlag.Designtimeprediction]: { cloudbees: 'Enable Design Prediction' },
  [FeatureFlag.Infielddesignsw]: {
    cloudbees: 'Add Infield Design for Siteworks',
  },
  [FeatureFlag.Sharedevices]: {
    cloudbees: 'Share Devices for Account and Project',
  },
  [FeatureFlag.Calibrationshareddevices]: {
    cloudbees: '15470 - Import calibration from shared Data collectors',
  },
  [FeatureFlag.Deletepartners]: { cloudbees: 'Delete Partners' },
  [FeatureFlag.Globalsearch]: { cloudbees: '17453 - Global Search' },
  [FeatureFlag.Designviewer]: { cloudbees: 'Bombsquad-678 - Design Viewer' },
  [FeatureFlag.Dataprep]: { cloudbees: 'WM-100 - Site Model' },
  [FeatureFlag.Uploadpreview]: { cloudbees: 'Bombsquad - Upload Previewer' },
  [FeatureFlag.Designviewerbackground]: {
    cloudbees: 'Bombsquad - 2D Tilemap for design viewer',
  },
  [FeatureFlag.Designviewerlayermanager]: {
    cloudbees: 'Bombsquad - Layer manager for design viewer',
  },
  [FeatureFlag.Designviewerpropertiespanel]: {
    cloudbees: 'Properties panel for design viewer',
  },
  [FeatureFlag.Backgroundimagesviewer]: {
    cloudbees: 'Background Images Viewer',
  },
  [FeatureFlag.Earthworksoperator]: {
    cloudbees: '17302 - Earthworks Operator screen access',
  },
  [FeatureFlag.Geoimagesearthworks]: {
    cloudbees: 'Publish Geo-referenced Images to Earthworks',
  },
  [FeatureFlag.Machineplayback]: { cloudbees: 'Weka-19709 - Machine Playback' },
  [FeatureFlag.Machinediary]: { cloudbees: 'Weka-17394 - Machine Diary' },
  [FeatureFlag.Groundworksdiary]: { cloudbees: 'WM-169 - GroundWorks Report' },
  [FeatureFlag.Machinediarydailyreport]: {
    cloudbees: 'Weka-17394 - Machine Diary Daily Report',
  },
  [FeatureFlag.WorkOrderBulkActions]: {
    cloudbees: '18783 - Archive, Unarchive and Delete Work Orders',
  },
  [FeatureFlag.Siteworksscreenview]: {
    cloudbees: '20093 - Siteworks Android Remote access with ScreenView',
  },
  [FeatureFlag.Workorders]: {
    cloudbees: '20241 - Work Orders from Job Service',
  },
  [FeatureFlag.Landxmldirectpublish]: {
    cloudbees: '20340 - Publish LandXML to Earthworks directly - CRUD',
  },
  [FeatureFlag.EulaModal]: { cloudbees: '18098 - End User License Agreement' },
  [FeatureFlag.Nosyncstatusforsiteworks]: {
    cloudbees: 'NoSync Device Status for Siteworks',
  },
  [FeatureFlag.BulkLicenseStatus]: { cloudbees: 'Bulk Device Licenses' },
  [FeatureFlag.FileExplorerDelete]: {
    cloudbees: 'File Explorer Delete Operation',
  },
  [FeatureFlag.Iso]: { cloudbees: 'ISO Feature' },
  [FeatureFlag.Photogrammetry]: { cloudbees: 'WM - Photogrammetry' },
  [FeatureFlag.PhotogrammetryTrimbleAccessGcps]: {
    cloudbees: 'WM - Photogrammetry - Trimble Access GCPs',
  },
  [FeatureFlag.PhotogrammetryDeleteGcps]: {
    cloudbees: 'WM - Photogrammetry - Delete GCPs',
  },
  [FeatureFlag.PhotogrammetryGcpUnits]: {
    cloudbees: 'WM - Photogrammetry - GCP Units',
  },
  [FeatureFlag.PhotogrammetrySurfaceOutput]: {
    cloudbees: 'WM - Photogrammetry - Surface',
  },
  [FeatureFlag.PhotogrammetryPpRtx]: {
    cloudbees: 'WM - Photogrammetry - PP-RTX',
  },
  [FeatureFlag.Civil3dViewer]: { cloudbees: 'Civil 3D Viewer' },
  [FeatureFlag.Civil3dViewerDesignPackageManager]: {
    cloudbees: 'Civil 3D Design Package Manager',
  },
  [FeatureFlag.Civil3dViewerProjectDataPanel]: {
    cloudbees: 'Civil Project Data Panel',
  },
  [FeatureFlag.Civil3dViewerToolbar]: { cloudbees: 'Civil 3D Toolbar' },
  [FeatureFlag.Civil3dNonVclEditing]: {
    cloudbees: 'Site Viz Editing of Non-VCL Files',
  },
  [FeatureFlag.Civil3dMultiUserDataPrep]: {
    cloudbees: 'Site Viz Multi User Data Preparation',
  },
  [FeatureFlag.Civil3dSplitJoin]: {
    cloudbees: 'Site Viz Enable Line Split and Join Tools',
  },
  [FeatureFlag.Civil3dEnableTranslationButtons]: {
    cloudbees: 'Site Viz Enable Translation and Rotation Tools',
  },
  [FeatureFlag.Raauthentication]: { cloudbees: '23112 - RA Authentication' },
  [FeatureFlag.Radynamicscope]: { cloudbees: '30500 - RA Dynamic Scope' },
  [FeatureFlag.Civil3dViewerTerrainSurfaceTexturing]: {
    cloudbees: 'Site Viz Terrain and Surface Texturing',
  },
  [FeatureFlag.Civil3dViewerOrthoImagery]: {
    cloudbees: 'Site Viz Orthoimagery',
  },
  [FeatureFlag.Civil3dViewerFieldDataImporter]: {
    cloudbees: 'Site Viz Field Data Importer',
  },
  [FeatureFlag.Civil3dViewerConnectDataImporter]: {
    cloudbees: 'Site Viz Connect Importer',
  },
  [FeatureFlag.Civil3dViewer3dTerrain]: { cloudbees: 'Site Viz 3D Terrain' },
  [FeatureFlag.Civil3dViewerS2SVolumetricMeasurements]: {
    cloudbees: 'Site Viz Surface-to-Surface Volumetric Measurements',
  },
  [FeatureFlag.Revokeselfinvite]: { cloudbees: 'WM - Remove Self-Invite' },
  [FeatureFlag.Wmchatassistant]: { cloudbees: 'WM Chat Assistant' },
  [FeatureFlag.Wmchataguiv2]: { cloudbees: 'WM Chat Assistant - AG UI V2' },
  [FeatureFlag.Wmchatplatformagent]: {
    cloudbees: 'WM Chat Assistant - Platform Agent',
  },
  [FeatureFlag.Customisableunitsettings]: {
    cloudbees: 'WM - Customisable Unit Settings',
  },
  [FeatureFlag.Civil3dViewerDrillingAndPiling]: {
    cloudbees: 'Site Viz Drilling and Piling',
  },
  [FeatureFlag.FolderContentsDelete]: {
    cloudbees: 'FolderOps - Delete With Contents',
  },
  [FeatureFlag.OtaSupportForRW]: { cloudbees: 'OTA Support for RW devices' },
  [FeatureFlag.Civil3dViewerVolumeMeasurementGraphics]: {
    cloudbees: 'Site Viz Volume Measurement Graphics',
  },
  [FeatureFlag.ProjectMigrationManually]: {
    cloudbees: 'Enable Project Migration Manually',
  },
  [FeatureFlag.Civil3dViewerVolumeHeatmapColorPalette]: {
    cloudbees: 'Site Viz Volume Heatmap Color Palette',
  },
  [FeatureFlag.Civil3dViewerTerrainTimeline]: {
    cloudbees: 'Site Viz Terrain Timeline',
  },
  [FeatureFlag.Civil3dViewerTerrainTimelinePhase2]: {
    cloudbees: 'Site Viz Terrain Timeline Phase 2',
  },
  [FeatureFlag.Civil3dViewerTerrainTimelinePhase3]: {
    cloudbees: 'Site Viz Terrain Timeline Phase 3',
  },
  [FeatureFlag.Civil3dViewerModelSpaceEditing]: {
    cloudbees: 'Site Viz Enable create/update/delete of model spaces',
  },
  [FeatureFlag.Civil3dTextEditing]: { cloudbees: 'Site Viz Text Editing' },
  [FeatureFlag.Civil3dViewerAgent]: { cloudbees: 'Site Viz Agent' },
  [FeatureFlag.Civil3dViewerSectionsGeneration]: {
    cloudbees: 'Site Viz 3D Sections Generation',
  },
  [FeatureFlag.AnalyticsDashboard]: { cloudbees: 'WM - Analytics Dashboard' },
  [FeatureFlag.DeletedItems]: { cloudbees: 'WM - Deleted Items' },
  [FeatureFlag.Civil3dViewerIssueManagement]: {
    cloudbees: 'Site Viz Issue Management',
  },
  [FeatureFlag.Happycamper]: { cloudbees: 'Happy Camper - Phase 2' },
  [FeatureFlag.Civil3dViewerDataDetailView]: {
    cloudbees: 'Site Viz Data Detail View',
  },
  [FeatureFlag.DraftingToolsv2]: { cloudbees: 'Site Viz Drafting Tools V2' },
  [FeatureFlag.CrsProjectSettings]: { cloudbees: 'CRS Orchestration Enable' },
  [FeatureFlag.Civil3dViewerFeaturesServices]: {
    cloudbees: 'Geovector Feature Service',
  },
  [FeatureFlag.Civil3dViewerWireframe]: { cloudbees: 'Site Viz Wireframe' },
  [FeatureFlag.Civil3dViewerLayersPanel]: { cloudbees: 'Site Viz LayersPanel' },
  [FeatureFlag.Civil3dViewerVolumeHeatmapPaletteBarStopEditing]: {
    cloudbees: 'Site Viz Heatmap Palette Bar Stop Dragging',
  },
  [FeatureFlag.Civil3dViewerTerrainVolumetric]: {
    cloudbees: 'Site Viz Terrain Volumetric',
  },
  [FeatureFlag.DeviceStatusMessage]: {
    cloudbees: 'Device Status Message Enhancement',
  },
  [FeatureFlag.Civil3dViewerPhotogrammetryMissions]: {
    cloudbees: 'Site Viz Photogrammetry Missions',
  },
  [FeatureFlag.Civil3dViewerRemoteOverride]: {
    cloudbees: 'Site Viz Remote Override',
  },
  [FeatureFlag.SiteVizPdfImport]: { cloudbees: 'Site Viz PDF Import' },
  [FeatureFlag.TestFeature001]: { connect: 'test-feature-001' },
  [FeatureFlag.FeatureExtraction]: { config: 'featureExtraction' },
};

export const getSourceFlagName = (
  flag: FeatureFlag,
  source: FeatureFlagSourceName
): string | undefined => FEATURE_FLAG_SOURCE_NAMES[flag][source];

export const getSourceFlagNames = (source: FeatureFlagSourceName): string[] =>
  Object.values(FeatureFlag).flatMap(
    (flag) => getSourceFlagName(flag, source) ?? []
  );
